import { Card, CardBody, CardTitle, CardText } from 'reactstrap';

function IconCard({ title, text, icon: Icon }) {
  return (
    <Card 
      style={{ width: "14rem", backgroundColor: '#33C2F4' }} // Lighter blue background
      className="shadow-sm border-0 text-white"
    >
      <CardBody className="d-flex align-items-center p-2">
        <div 
          className="p-2 me-2"
          style={{ 
            backgroundColor: 'rgba(255, 255, 255, 0.25)', // Light white background for icon
            borderRadius: '50%' 
          }}
        >
          {Icon && <Icon size={24} className="text-white" />}
        </div>

        <div>
          <CardTitle tag="h6" className="mb-1" style={{ fontSize: '0.8rem' }}>
            {title}
          </CardTitle>
          <CardText className="h5 fw-bold mb-0" style={{ fontSize: '1.2rem' }}>
            {text}
          </CardText>
        </div>
      </CardBody>
    </Card>
  );
}

export default IconCard;
